import {State} from "../../redux/state";

export const notificationsSelector = (state: State) => state.notifications;
